const PROJECT_LIST_VIEW_SELECTION = { selected: 'MyProjects', category: 'Projects' };
const TEMPLATE_LIST_VIEW_SELECTION = { selected: 'Explore', category: 'Templates' };
const GETTING_STARTED_VIEW_SELECTION = { selected: 'Getting Started', category: 'Resources' };

export { PROJECT_LIST_VIEW_SELECTION, TEMPLATE_LIST_VIEW_SELECTION, GETTING_STARTED_VIEW_SELECTION };
